import React from "react";

export default function TripleGrid({ backgroundCol, cardData, head, head2 }) {
  return (
    <div
      className={`${
        backgroundCol ? backgroundCol : "bg-darkBlue"
      } flex items-center justify-center flex-col py-32`}
    >
      {head ? (
        head
      ) : (
        <div className="mainHead py-6 text-white  2xl:w-7/12 lg:w-9/12 w-full  justify-center text-center">
          <h2 className="lg:text-4xl font-secondary leading-8 text-3xl font-bold pt-12">
            Commonly Translated Financial Documents
          </h2>
          <span className="border-b border-textlight mt-16 w-full block"></span>
        </div>
      )}
      {head2 ? (
        <div className="mainHead py-6 text-white  2xl:w-7/12 xl:w-9/12 w-full justify-center px-10 xl:px-0">
          <h2 className="lg:text-4xl font-secondary leading-8 text-3xl font-bold pt-12">
            The Financial Translation{" "}
            <span className="text-orange">Process</span>
          </h2>
          <p className="pt-8">
            The financial translation process is governed by painstaking
            adherence to security and confidentiality provisions to ensure
            privacy and non-disclosure of sensitive information and data.
          </p>
          <span className="border-b border-[#FF7B16] mt-16 w-full block"></span>
        </div>
      ) : null}
      {/* <div className="flex justify-center mx-auto"> */}
      <div className="cardsDiv 2xl:w-9/12 w-full text-white text-center flex flex-wrap 2xl:justify-start xl:pl-[8rem] gap-x-10 max-w-screen-2xl">
        {cardData
          ? cardData.map(
              ({ head, content, image, firstHead, lastHead, imagE }) => (
                <div className="cardComp w-full lg:px-8 px-4 sm:px-20 xl:w-[30%] py-10">
                  {imagE ? (
                    imagE
                  ) : (
                    <img src={image} alt={image} className="my-4" />
                  )}
                  <h3 className="pb-4 text-xl font-bold text-left">
                    {" "}
                    <span className="text-orange">{firstHead}</span> {head}{" "}
                    <span className="text-orange">{lastHead}</span>{" "}
                  </h3>

                  <p className="text-darkMist leading-8 text-left font-opensans">
                    {content}
                  </p>
                </div>
              )
            )
          : null}
      </div>
    </div>
    // </div>
  );
}
